import { createGlobalState } from '@vueuse/core';
import { ref, computed } from 'vue';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { EmbodimentService } from '../service/embodiment-service';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import type { EmbodimentState } from '../types';

export const useEmbodiment = createGlobalState(() => {
    const embodimentService = injectService<EmbodimentService>(EmbodimentService);

    const { disposes } = useDisposes();

    const modelData = ref<EmbodimentState>(embodimentService.getModelData());
    disposes.push(embodimentService.onStateChange(state => modelData.value = state));

    const isGeneratingEmbodiment = computed(() => modelData.value.isGenerating);

    const embodiment = computed(() => modelData.value);

    async function generateEmbodiment() {
        await embodimentService.generateEmbodiment();
    }

    function restEmbodiment() {
        embodimentService.resetEmbodiment();
    }

    function updateEmbodimentContent(content: string) {
        embodimentService.updateEmbodimentContent(content);
    }

    return {
        embodiment,
        isGeneratingEmbodiment,
        generateEmbodiment,
        restEmbodiment,
        updateEmbodimentContent,
    };
});
